// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenu":"dropdown-menu_dropdownMenu__k8u3i"};